export const getUserDataFromLocalStorage = () => {
  const localData: any = localStorage.getItem("userAllData");
  const userData: any = localData ? JSON.parse(localData) : null;
  return userData;
};

export const enum AWSUserStatus {
  CONFIRMED = "CONFIRMED",
  UNCONFIRMED = "UNCONFIRMED",
  EXTERNAL_PROVIDER = "EXTERNAL_PROVIDER",
  FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD",
}

export const titleCase = (str: any) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};

export const scrollToErrorByClass = (errors: any, isObj?: boolean) => {
  let catchedInputErrorElement: any = null;
  if (isObj) {
    catchedInputErrorElement = document.querySelector(
      `input[name=${Object.keys(errors)[0]}]`
    );
  } else {
    catchedInputErrorElement = document.querySelector(
      `input[name=${errors[0]}]`
    );
  }
  if (!catchedInputErrorElement) {
    if (isObj) {
      [catchedInputErrorElement] = document.getElementsByClassName(
        Object.keys(errors)[0]
      );
    } else {
      [catchedInputErrorElement] = document.getElementsByClassName(errors[0]);
    }
  }
  if (catchedInputErrorElement) {
    catchedInputErrorElement.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  }
};

export const findParents = (childKey: any, data: any) => {
  const parents = [];
  let currentKey = childKey;
  while (currentKey) {
    const parent = data.find((item: any) => item.key === currentKey);
    if (!parent) break; // If parent not found, exit loop
    parents.unshift(parent); // Add parent to the beginning of the array
    currentKey = parent.parentKey;
  }
  return parents;
};

export const checkColorCode = (index: any) => {
  switch (index) {
    case 5:
      return "#858585";
    case 4:
      return "#FF8F66";
    case 3:
      return "#FFEF5C";
    case 2:
      return "#FFEF5C";
    default:
      return "#98E565";
  }
};

export const getDeviceStrokeColor = (deviceIdx: any, roomBackColorIdx: any) => {
  //0 = white, 1 = Green, 2 = Yellow, 3 = Yellow, 4 = Red, 5 = Black
  let strokeColor = "#000000";
  if (roomBackColorIdx == "-Infinity" || roomBackColorIdx == "0") {
  } else if (roomBackColorIdx == "1") {
  } else if (roomBackColorIdx == "2" || roomBackColorIdx == "3") {
  } else if (roomBackColorIdx == "4") {
    strokeColor = "#FFFFFF";
  } else if (roomBackColorIdx == "5") {
    strokeColor = "#FFFFFF";
  }

  return strokeColor;
};
export function formatNumber(value: any) {
  if (value >= 100000) {
    return (value / 100000).toFixed(0) + "L"; // Convert to Lakh (100K)
  } else if (value >= 1000) {
    return (value / 1000).toFixed(0) + "K"; // Convert to Thousand (1K, 30K, etc.)
  }
  return value.toString(); // Return as is if less than 1000
}


export const getNumberUnits = (num: any, subSstaneKey?:any, Subunit?:any) => {

  const checkWithSubstanceZeroDecimal = ["pcc10","pcc2dot5"]
  const checkWithSubstanceOneDecimal = ["pm10","pm2dot5"]
  const checkWithSubstanceBioPercentage = ["pm_biop","pc_biop"]

  const units: string[] = ["", "K", "M", "B", "T", "Q"];
  let numStr: string = Math.abs(num).toFixed(0);

  // Bio should use a similar  method as  Particulates, label: #/m3(No round) ug/3(Round to .x)
  if(!!subSstaneKey && subSstaneKey === 'pm_bio'){
    if(!!Subunit && Subunit === 'ug/m3'){
      numStr  = Math.round(num).toFixed(0);
    }
    if(!!Subunit && Subunit === '#/m3'){
      numStr  = Number(num).toFixed(0);
    }    
  }  
  const unit: number = Math.floor((numStr.length - 1) / 3);
  const scaledNum: number = num / Math.pow(10, unit * 3);
  let roundedNum: string = scaledNum % 1 === 0 ? scaledNum.toString() : scaledNum.toFixed(2);
  if(!!subSstaneKey && checkWithSubstanceZeroDecimal.includes(subSstaneKey)){
    roundedNum = scaledNum % 1 === 0 ? scaledNum.toString() : scaledNum.toFixed(0);
  }else if(!!subSstaneKey && checkWithSubstanceOneDecimal.includes(subSstaneKey)){
    roundedNum = scaledNum % 1 === 0 ? scaledNum.toString() : scaledNum.toFixed(1);
  }
  if(!!subSstaneKey && checkWithSubstanceBioPercentage.includes(subSstaneKey)){
    const roundedNumber:number =  Number((Number(num)/39830*100).toFixed(2))
    if(roundedNumber < 0.2){
      return roundedNum = Number(0).toFixed(0)
    }
    if(roundedNumber >= 0.2 && roundedNumber < 100){
      return roundedNum = (Number(num)/39830*100).toFixed(1)
    }else if(roundedNumber >= 100){
      return roundedNum = Number(100).toFixed(0)
    }else{
      return 0
    }    
  }

  // Bio Index every time send pm_bioi for ug/m3 or #/m3
  if(!!subSstaneKey && (subSstaneKey === 'pm_bioi' || subSstaneKey === 'pc_bioi')){
      if(!!Subunit && Subunit === 'ug/m3'){        
        const roundedNumber:number =  Number((Number(num)/150).toFixed(2))
        if(roundedNumber < 0.1){
          return roundedNum = "-"
        }
        if(roundedNumber >= 0.1){
          return roundedNum = (Number(num)/150).toFixed(2)
        }
    }
    if(!!Subunit && Subunit === '#/m3'){
      const roundedNumber:number =  Number((Number(num)/3000000).toFixed(2))
      if(roundedNumber < 0.1){
        return roundedNum = "-"
      }
      if(roundedNumber >= 0.1){
        return roundedNum = (Number(num)/3000000).toFixed(2)
      }
    }     
  }

  return roundedNum + units[unit];
};

export const whiteClr = "#FFFFFF !important";
export const blackClr = "#000000 !important";

export const  formatEmailAsterisks = async (emilString:any) => {
  let splitEmail = emilString.split("@")
  let domain = splitEmail[1];
  let name = splitEmail[0];
  return  name.substring(0,3).concat("*********@").concat(domain)
}

export const scheduleTimeOptions = [
  {
    label: "Yesterday",
    value: "last_day",
  },
  {
    label: "Last Week",
    value: "last_week",
  },
  {
    label: "Last Month",
    value: "last_month",
  },
];

export const LocationDataDeviceByType = (locationArray:any) => {   
  const groupedByTypeAndParent = locationArray.reduce((acc:any, item:any) => {
      if (!acc[item.type]) {
          acc[item.type] = {}; // Using Set to avoid duplicates
      }
      if (!acc[item.type][item.parentKey]) {
        acc[item.type][item.parentKey] = new Set(); // Use Set to avoid duplicates
      }
      acc[item.type][item.parentKey].add(item.key);
      return acc;
  }, {});
  // Convert Sets to Arrays
  const result = Object.fromEntries(
    Object.entries(groupedByTypeAndParent).map(([type, parents]:any) => [
        type,
        Object.fromEntries(Object.entries(parents).map(([parentKey, keys]:any) => [parentKey, Array.from(keys)]))
    ])
  );
  return result
}